import { cn } from '@/lib/utils/tailwind';

import type { ElementType, ReactNode, Ref } from 'react';

interface ItemPrefixProps<T extends ElementType = 'span'> {
  as?: T;
  className?: string;
  children: ReactNode;
  ref?: Ref<HTMLSpanElement>;
}

const ItemPrefix = <T extends ElementType = 'span'>({
  as,
  className,
  children,
  ref,
  ...props
}: ItemPrefixProps<T>) => {
  const Component = as || 'span';
  return (
    <Component className={cn('justify-start', className)} ref={ref} {...props}>
      {children}
    </Component>
  );
};

export { ItemPrefix, type ItemPrefixProps };
